var React = require('react');

function Bible (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M96 448c-19.2 0-32-12.8-32-32s16-32 32-32h319.33c-1.93 16.24-1.76 48.38.53 64z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M96 384h328a24 24 0 0 0 24-24V32a32 32 0 0 0-32-32H96A96 96 0 0 0 0 96v320a96 96 0 0 0 96 96h328a24 24 0 0 0 24-24v-16a24 24 0 0 0-24-24H96c-19.2 0-32-12.8-32-32s16-32 32-32zm48-240a16 16 0 0 1 16-16h48V80a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16v48h48a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16h-48v112a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V192h-48a16 16 0 0 1-16-16z","className":"fa-primary","key":2})]);
}

Bible.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = Bible;

Bible.default = Bible;
